import React from "react";
import PaletteCouleursAffichageToutes from "../../../../boiteAOutils/PaletteCouleursAffichageToutes";

const SidebarDrawSettings = ({
                                 setSidebarVisible,
                                 drawingSettings
                                 , setDrawingSettings
                             }) => {

    const [style, setStyle] = React.useState("Stylo");

    const handleChangeStyle = (e) => {
        const selectedStyle = e.target.value;
        setStyle(selectedStyle);

        if (selectedStyle === "Stylo") {
            setDrawingSettings(prev => ({ ...prev, brushSize: 1 }));
        } else if (selectedStyle === "Crayon") {
            setDrawingSettings(prev => ({ ...prev, brushSize: 3 }));
        } else if (selectedStyle === "Feutre") {
            setDrawingSettings(prev => ({ ...prev, brushSize: 6 }));
        }
    };

    const handleChangeBrushSize = (e) => {
        const size = Number(e.target.value);
        setDrawingSettings(prev => ({ ...prev, brushSize: size }));

        // Met à jour le style en fonction de l'épaisseur
        if (size === 1) {
            setStyle("Stylo");
        } else if (size === 3) {
            setStyle("Crayon");
        } else if (size === 6) {
            setStyle("Feutre");
        } else {
            setStyle("Personnalisé");
        }
    };


    return (
        <>
            <div className="sidebar-titre">
                Dessin
                <button onClick={() => setSidebarVisible(false)} className="toggle-button">
                    X
                </button>
            </div>

            <div className="sidebar-section">Pinceau</div>
            <div className="sidebar-choix">
                <div className="libelle">Style</div>
                <select value={style} onChange={handleChangeStyle}>
                    <option>Stylo</option>
                    <option>Crayon</option>
                    <option>Feutre</option>
                    <option>Personnalisé</option>
                </select>
            </div>

            <div className="sidebar-choix">
                <div className="libelle">Épaisseur</div>
                <select onChange={handleChangeBrushSize} value={drawingSettings.brushSize}>
                    {[...Array(8)].map((_, i) => (
                        <option key={i} value={i + 1}>{i + 1}</option>
                    ))}
                </select>
            </div>

            <div className="sidebar-section">Couleur</div>
            <PaletteCouleursAffichageToutes
                defaultColor={drawingSettings.color}
                onColorChange={(color) => setDrawingSettings(prev => ({ ...prev, color: color }))}
            />
        </>
    );
};

export default SidebarDrawSettings;
